import api from "../../../core/api";
import { Page } from "../../../shared/models/models";
import { Product, ProductsQuery } from "../models/customerSearchAndBuyModels";

const getRequestConfig = () => {
  return { baseURL: (window as any).app.config.catalogApiBaseUrl };
}

class CustomerProductsApi {
  getProducts(query: ProductsQuery): Promise<Page<Product>> {
    return api.get<Page<Product>>(`/v1/products`, { ...getRequestConfig(), params: query}).then(x => x.data);
  }
}

export default new CustomerProductsApi();